import { Partner } from '@/configs/partner';
import { ESSENCE_CUSTOMER_ID } from '@/constants/customers';

const HIPAA_CUSTOMER_IDS = new Set<string>([ESSENCE_CUSTOMER_ID]);

// Transitional: retire this subdomain signal when the essence subdomain is
// removed and Essence moves under `business`. After that, customerId is the
// sole HIPAA signal.
const HIPAA_SUBDOMAINS = new Set<Partner>([Partner.essence]);

export const isHipaa = ({
  partner,
  customerIds,
}: {
  partner?: Partner;
  customerIds?: readonly string[];
}): boolean =>
  (!!partner && HIPAA_SUBDOMAINS.has(partner)) ||
  (customerIds?.some((id) => HIPAA_CUSTOMER_IDS.has(id)) ?? false);
